// src/components/common/IntercomHider.js
import { useEffect } from 'react';

const IntercomHider = () => {
  useEffect(() => {
    // Crear un elemento de estilo
    const style = document.createElement('style');
    style.innerHTML = `
      /* Ocultar el launcher predeterminado de Intercom */
      .intercom-lightweight-app, 
      #intercom-container .intercom-launcher-frame, 
      #intercom-container .intercom-launcher {
        display: none !important;
        opacity: 0 !important;
        pointer-events: none !important;
      }
    `;
    
    // Añadir al head del documento
    document.head.appendChild(style);
    
    // Limpiar al desmontar
    return () => {
      document.head.removeChild(style);
    };
  }, []);
  
  return null;
};

export default IntercomHider;